import React, { useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Dropdown } from "react-bootstrap";
import "./NavbarStyles.css";
import { FaPhoneAlt } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import emailjs from "emailjs-com";
import { IoMail } from "react-icons/io5";
import { CiClock2 } from "react-icons/ci";
import { FaLocationDot } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { FaYoutube } from "react-icons/fa6";
import { AiFillGoogleCircle } from "react-icons/ai";

const Header = () => {
  const form = useRef();
  const [data, updateData] = useState({
    Name: "",
    Email: "",
    Number: "",
    Subject: "",
    Message: "",
  });

  const { Name, Email, Number, Subject, Message } = data;

  const changeHandler = (e) => {
    updateData({ ...data, [e.target.name]: [e.target.value] });
  };
  const submitHandler = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_d7nkc98",
        "template_dhs0a87",
        e.target,
        "-_ajGXvF0DTOYDkQE"
      )
      .then(
        (result) => {
          alert("Successfully Booked Your Appointment ");
          updateData({
            Name: "",
            Email: "",
            Number: "",
            Subject: "",
            Message: "",
          });
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // for scrolling styles

  const [navchange, setNavbar] = useState(false);
  const changebackground = () => {
    if (window.scrollY >= 150) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changebackground);
  return (
    <>
      <div className="text-center main_logo">
        <div className="container">
          <div className="row">
            <div className="col-md-2 col-sm-12 d-flex Threeparts">
              <FaPhoneAlt className="mobile_Logo" />
              <a className="mobile_content" href="tel:9441246269">
                + 91 9441246269
              </a>
            </div>
            <div className="col-md-6 col-sm-12 d-flex Sixparts">
              <div className="d-flex">
                <IoMail className="Mail_Logo" />
                <p className="mail_content">Contact@pinnamanenihospital.com</p>
              </div>
              <div className="d-flex">
                <FaLocationDot className="Mail_Logo" />
                <p className="mail_content">Katuru Rd, Vuyyuru</p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12 d-flex icons">
              <a href="">
                <FaFacebook className="iconlist" />
              </a>
              <a href="">
                <RiInstagramFill className="iconlist" />
              </a>
              <a href="">
                <FaYoutube className="iconlist" />
              </a>
              <a href="">
                <AiFillGoogleCircle className="iconlist" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="displayOnPc">
        <Navbar
          collapseOnSelect
          expand="lg"
          className={
            navchange
              ? "active bg-body-tertiary navbar shadow-sm p-2 mb-5 bg-body rounded fixed-top"
              : "notfixed bg-body-tertiary navbar shadow-sm p-2 mb-5 bg-body rounded"
          }
        >
          <Container>
            <img src="Logo.png" alt="" className=""></img>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ms-auto" navbarScroll>
                <Nav.Link href="Home" className="navitems">
                  HOME
                </Nav.Link>
                <Nav.Link href="About" className="navitems">
                  ABOUT US
                </Nav.Link>
                <Dropdown className="dropmenu">
                  <Dropdown.Toggle variant="" className="dropdown">
                    DOCTORS
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mt-3" id="Submenu">
                    <Dropdown.Item
                      href="Dr_Pawan_Kalyan"
                      className="galleryitemed"
                    >
                      Dr. PawanKalyan
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="Dr_G_Sree_Lakshmi"
                      className="galleryitemed"
                    >
                      Dr. G.Sree Lakshmi
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown className="dropmenu">
                  <Dropdown.Toggle variant="" className="dropdown">
                    SERVICES
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mt-3" id="Submenu">
                    <Dropdown.Item
                      href="Obstetric_And_Gynaecology"
                      className="galleryitemed"
                    >
                      Obstetric & Gynaecology
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="Fertility_Care"
                      className="galleryitemed"
                    >
                      Fertility Care
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="Pediatric_Pulmonologist"
                      className="galleryitemed"
                    >
                      Pediatric Pulmonologist
                    </Dropdown.Item>
                    <Dropdown.Item href="Cardiology" className="galleryitemed">
                      Cardiology
                    </Dropdown.Item>
                    <Dropdown.Item href="Neurology" className="galleryitemed">
                      Neurology
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Nav.Link href="Gallery" className="navitems">
                  GALLERY
                </Nav.Link>
                <Nav.Link href="" className="navitems">
                  BLOGS
                </Nav.Link>
                <Nav.Link href="Contact" className="navitems">
                  CONTACT
                </Nav.Link>
                <Nav.Link onClick={handleShow} className="navitems">
                  APPOINTMENT
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      {/* <div id='navbarDisplay'>
        <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary navbar shadow-sm p-2 mb-5 bg-body rounded fixed-top">
          <Container>
            <img src='Logo.png' alt='' className=''></img>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="navlinks" navbarScroll>
                <Nav.Link href="Home" className='navitems'>HOME</Nav.Link>
                <Nav.Link href="Dr_Srinivas_Polisetty_Best_orthopedic_Doctor_in_Guntur" className='navitems'>ABOUT US</Nav.Link>
                <Dropdown className='dropmenu'>
                  <Dropdown.Toggle variant="" className='dropdown'>
                    SERVICES
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="mt-2" id='Submenu'>
                    <Dropdown.Item href="Therapy_Free_Total_Knee_Replacement_by_Dr_Srinivas_Polisetty_orthopedic_Doctor_in_Guntur" className='galleryitemed'>Therapy-Free Total Knee Replacement</Dropdown.Item>
                    <Dropdown.Item href="Fast_Track_Knee_Replacement_by_Dr_Srinivas_Polisetty_orthopedic_Doctor_in_Guntur" className='galleryitemed'>Fast-Track Knee Replacement</Dropdown.Item>
                    <Dropdown.Item href="Revision_Total_Knee_Replacement_Surgery_by_Dr_Srinivas_Polisetty_In_Guntur" className='galleryitemed'>Revision TKR</Dropdown.Item>
                    <Dropdown.Item href="Arthroscopy_In_guntur" className='galleryitemed'>Arthroscopy (Key Hole Surgery)</Dropdown.Item>
                    <Dropdown.Item href="Regenerative_knee_treatment" className='galleryitemed'>Regenerative knee treatment</Dropdown.Item>
                    <Dropdown.Item href="Fracture_management_guntur" className='galleryitemed'>Fracture Management</Dropdown.Item>
                    <Dropdown.Item href="Fast_track_hip_joint_replacement_in_Guntur" className='galleryitemed'>Fast Track Hip Joint Replacement</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Nav.Link href="Gallery" className='navitems'>GALLERY</Nav.Link>
                <Nav.Link href="Blogs" className='navitems'>BLOGS</Nav.Link>
                <Nav.Link href="Social_Media" className='navitems'>CONTACT</Nav.Link>
                <Nav.Link href="tel: 077606 03287" className="navitems appointment-btn" onClick={handleShow}>APPOINTMENT</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div> */}

      <Modal style={{ marginTop: "50px" }} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{ color: "#722e85", textAlign: "center" }}
          >
            Book An Appointment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form ref={form} onSubmit={submitHandler}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input
                type="text"
                value={Name}
                onChange={changeHandler}
                className="form-control"
                placeholder="Your Name"
                name="Name"
                required="Username is Required..."
                message="Username must be atmost 30 characters long..."
                style={{ padding: "10px" }}
              />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input
                type="email"
                value={Email}
                onChange={changeHandler}
                className="form-control"
                placeholder="Your Email Address"
                name="Email"
                id="email"
                required="Email is required"
                data-error="Please enter your email"
                fdprocessedid="p2hd6j"
                style={{ padding: "10px" }}
              />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input
                type="text"
                value={Number}
                onChange={changeHandler}
                className="form-control"
                name="Number"
                placeholder="Phone Number"
                id="phone_number"
                required="Number is Required"
                data-error="Please enter your number"
                fdprocessedid="cf7ig"
                style={{ padding: "10px" }}
              />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <input
                type="text"
                value={Subject}
                onChange={changeHandler}
                className="form-control"
                name="Subject"
                placeholder="Subject"
                id="msg_subject"
                required="Subject is Required"
                data-error="Please enter your subject"
                fdprocessedid="4mor3e"
                style={{ padding: "10px" }}
              />
              <div className="help-block with-errors"></div>
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <textarea
                name="Message"
                value={Message}
                onChange={changeHandler}
                className="form-control"
                id="message"
                cols="30"
                rows="3"
                placeholder="Type Your Message Here"
                required="Message is required"
                data-error="Write your message"
              ></textarea>
              <div className="help-block with-errors"></div>
            </Form.Group>
            <button
              type="submit"
              className="btn "
              name="contact"
              style={{ backgroundColor: "#e5097f", color: "whitesmoke" }}
            >
              Send Message
            </button>
            <div id="msgSubmit" className="h3 text-center hidden"></div>
            <div className="clearfix"></div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
